import { render, staticRenderFns } from "./app.vue?vue&type=template&id=56fde2ae&"
import script from "./app.ts?vue&type=script&lang=ts&"
export * from "./app.ts?vue&type=script&lang=ts&"
import style0 from "./app.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports